import React, { useState } from 'react';
import {
    TextField,
    Button,
    Container,
    Grid,
    Typography,
    Box,
    Paper,
    ThemeProvider,
    createTheme,
    Switch,
    FormGroup,
    FormControlLabel,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DescriptionIcon from '@mui/icons-material/Description';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import { useAuth } from '../../Auth/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { PermissionListAPI, RoleCreateAPI } from '../../Conections/RolesAndPermissionsConection';
import ErrorCard from '../../Conections/ErrorCard';
import { can } from '../../Conections/LogConections';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',
        },
        secondary: {
            main: '#dc004e',
        },
        background: {
            default: '#f5f5f5',
        },
    },
});

export default function CreateRoles() {

    const auth = useAuth();
    const goTo = useNavigate();
    const [expanded, setExpanded] = React.useState(false);
    const [datapermissions, setDatapermissions] = useState(null);
    const [datapermissionsv, setDatapermissionsv] = useState([]);
    const [permitido, setPermitido] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        description: '',
    });

    React.useEffect(() => {
        if (!auth.getToken()) {
            goTo("/login");
        }
        else {
            reloaduser();
            reloadPermisionv();
        }
    }, []);

    React.useEffect(() => {
        if (!auth.getToken()) {
            goTo("/login");
        }
        else {
            reloadPermisionv();
        }
    }, [datapermissions]);

    function reloadPermisionv() {
        if (
            datapermissions !== null
        ) {
            var vec = [];
            for (var i = 0; i < datapermissions.length; i++) {
                for (var j = 0; j < datapermissions[i].permissions.length; j++) {
                    vec[datapermissions[i].permissions[j].id] = 0;
                }
            }
            setDatapermissionsv(vec);
        }
    }

    async function reloaduser() {
        if (auth.getToken()) {
            const permisionCan = await can(auth.getToken(), auth.getCompany(), "/dashboard/rpp/createroles");
            if (permisionCan) {
                const datos = await PermissionListAPI(auth.getToken(), auth.getCompany());
                setDatapermissions(datos);
                setPermitido(permisionCan === 1);
            }
            else {
                goTo("/dashboard");
            }

        }
        else {
            goTo("/login");
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        var permisions = [];
        var con = 0;
        datapermissionsv.forEach((element) => {
            if (element > 0) {
                permisions[con] = element;
                con++;
            }
        });
        const datos = await RoleCreateAPI(
            auth.getToken(),
            auth.getCompany(),
            formData.name,
            formData.description,
            permisions
        );
        goTo(`/dashboard/rpp/showrole/${datos}`);
    };

    function changeswitch(index) {
        var tem = datapermissionsv;
        if (tem[index] === 0) {
            tem[index] = index;
        }
        else {
            tem[index] = 0;
        }
        setDatapermissionsv(tem);
    }

    const handleChangeA = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        permitido ? (
            <ThemeProvider theme={theme}>
                <Box
                    sx={{
                        minHeight: '100vh',
                        display: 'flex',
                        alignItems: 'center',
                        bgcolor: 'background.default',
                        py: 4,
                    }}
                >
                    <Container maxWidth="lg">
                        <Paper elevation={3} sx={{ p: 4 }}>
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={4}>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="h4" gutterBottom color="primary">
                                            Crear Nuevo Rol
                                        </Typography>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label="Name"
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                    InputProps={{
                                                        startAdornment: <AccountCircleIcon sx={{ mr: 1, color: 'action.active' }} />,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    label="Description"
                                                    name="description"
                                                    value={formData.description}
                                                    onChange={handleChange}
                                                    required
                                                    InputProps={{
                                                        startAdornment: <DescriptionIcon sx={{ mr: 1, color: 'action.active' }} />,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    fullWidth
                                                    size="large"
                                                >
                                                    Crear Role
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="h4" gutterBottom color="primary">
                                            Permissions
                                        </Typography>
                                        {datapermissions ?
                                            (datapermissions.map((section, index) => (
                                                <Accordion expanded={expanded === section.name} onChange={handleChangeA(section.name)} key={index}>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel1bh-content"
                                                        id="panel1bh-header"
                                                    >
                                                        <Typography sx={{ width: '33%', flexShrink: 0 }}>
                                                            {section.name}
                                                        </Typography>
                                                        <Typography sx={{ color: 'text.secondary' }}>
                                                            {section.description}
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <FormGroup>
                                                            {
                                                                section.permissions.map((permission, index) => (
                                                                    <FormControlLabel control={<Switch onClick={() => changeswitch(permission.id)} />} label={permission.name} key={index} />
                                                                ))
                                                            }
                                                        </FormGroup>
                                                    </AccordionDetails>
                                                </Accordion>

                                            ))
                                            ) : (
                                                <>Empty</>
                                            )
                                        }
                                    </Grid>
                                </Grid>
                            </form>
                        </Paper>
                    </Container>
                </Box>
            </ThemeProvider>
        ) : (
            <ErrorCard />
        )
    );
}
